import { onUnmounted } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { LOGIN_DATA, LoginData } from "@/lib/authHelper";
import { IS_BROWSER } from "@/lib/browserUtils";

const userIdOf = (value: string | null): string | null => {
  if (!value) return null;
  try {
    const id = (JSON.parse(value) as LoginData).user?.id;
    return id ? String(id) : null;
  } catch (e) {
    return null;
  }
};

// All tabs of the site share one account in localStorage (token and LOGIN_DATA). When another tab switches the account
// (Switch account of a Talent Rep, Login as user), this tab reloads under that account. Otherwise the tab keeps the old
// user in memory while the router guards read the new one from LOGIN_DATA, and a tab of the old account writes its
// refreshed token back over the switched one: after Switch account the Vault did not open (CO-15592).
export default function useFollowAccountOfOtherTabs() {
  if (!IS_BROWSER) return;
  const { authUser } = useAuthUser();

  const onStorage = (e: StorageEvent) => {
    if (e.key !== LOGIN_DATA || e.storageArea !== localStorage) return;
    const newUserId = userIdOf(e.newValue);
    // logout in another tab is handled by the api provider (SET_USER with null)
    if (!newUserId || !authUser.value || newUserId === String(authUser.value.id)) return;
    location.reload();
  };

  window.addEventListener("storage", onStorage);
  onUnmounted(() => window.removeEventListener("storage", onStorage));
}
